import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import VnButton from '@ui/components/VnButton';
import './style.css';
import ImageViewer from 'react-simple-image-viewer';
const AttachmentPreviewModal = ({ attachmentSrc, onClose }) => {
    const handleDownload = () => {
        const link = document.createElement('a');
        link.href = attachmentSrc;
        link.download = 'File';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };
    const isImage = attachmentSrc.startsWith('data:image');
    return (_jsxs(_Fragment, { children: [_jsx("div", { className: 'vn-Form_Footer mt-1', children: isImage ? (_jsx(ImageViewer, { src: [attachmentSrc], currentIndex: 0 })) : (_jsx("iframe", { src: attachmentSrc, className: 'vn-attachment-preview-container' })) }), _jsx("div", { className: 'vn-Form_Footer mt-4', children: _jsxs("div", { style: { display: 'flex', marginLeft: 'auto' }, children: [_jsx(VnButton, { customClassName: 'Vn-cancel-button', mode: 'secondary', onClick: onClose, type: 'button', children: "Annuleren" }), _jsx(VnButton, { customClassName: 'Vn-save-button vn-popup-save-button', mode: 'primary', type: 'button', onClick: handleDownload, children: "Downloaden" })] }) })] }));
};
export default AttachmentPreviewModal;
